import React, { useEffect, useState } from 'react'
import './index.scss'
import { useRouteError, useNavigate } from 'react-router-dom'
import ErrorImage from '@assets/images/error.png'

import Heading from '@ui/heading/heading'
import Button from '@ui/button/button'
import {
  eDaChunkSparito,
  ricaricaOra,
  ricaricaSeChunkSparito,
} from './ricaricaSeChunkSparito'

export const MESSAGGIO_GENERICO =
  "Siamo spiacenti, si è verificato un errore inaspettato. Si prega di riprovare più tardi o contattare l'assistenza se il problema persiste."

/* Quando la causa e' un chunk sparito il messaggio generico e' una bugia utile
   a nessuno: non e' un errore inaspettato, e' il sito che si e' aggiornato
   sotto i piedi. Dirlo cambia anche cosa fa l'utente. */
export const MESSAGGIO_CHUNK =
  'Il sito è stato aggiornato mentre lo stavi usando. Ricarica la pagina per continuare.'

const Error = () => {
  const errore = useRouteError()
  const navigate = useNavigate()

  /* `data` c'e' solo quando react-router lancia una Response con un payload
     suo. Prima si destrutturava senza guardia: con un Error grezzo, che e'
     proprio il caso del chunk sparito, non c'e'. */
  const data = errore && typeof errore === 'object' ? errore.data : undefined
  const daChunk = eDaChunkSparito(errore)
  const [ricaricando, setRicaricando] = useState(false)

  useEffect(() => {
    if (ricaricaSeChunkSparito(errore)) setRicaricando(true)
  }, [errore])

  /* La ricarica e' gia' partita: non si mostra un errore a chi sta per vedere
     la pagina buona, si dice cosa sta succedendo. */
  if (ricaricando) {
    return (
      <div className='Error Error--ricarica'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='col-xs-12 col-md-8 col-lg-6'>
              <p className='Error__text' role='status' aria-live='polite'>
                Aggiorno la pagina...
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const messaggio = data ?? (daChunk ? MESSAGGIO_CHUNK : MESSAGGIO_GENERICO)

  return (
    <div className='Error'>
      <div className='container'>
        <div className='row justify-center g-xs-1 g-sm-3 g-lg-4'>
          <div className='col-xs-12 col-md-8 col-lg-6'>
            <div className='Error__box'>
              <Heading
                className='Error__title'
                heading='h2'
                title='Abbiamo riscontrato un problema'
              />
              <p className='Error__text'>{messaggio}</p>
              <div className='Error__btn'>
                {/* Su un chunk sparito "Torna Indietro" non ripara niente: la
                    versione vecchia della pagina e' quella rotta. L'unica
                    uscita e' rileggere l'indice, cioe' ricaricare. */}
                {daChunk ? (
                  <Button variant='primary' size='lg' onClick={ricaricaOra}>
                    Ricarica
                  </Button>
                ) : (
                  <Button variant='primary' size='lg' onClick={() => navigate(-1)}>
                    Torna Indietro
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div className='col-xs-12 col-md-8 col-lg-6'>
            <img className='Error__image' src={ErrorImage} alt='error' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error
